module.exports = __webpack_public_path__ + "static/img/content_1.02e63dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/4/content_1.jpg
// module id = S3AI
// module chunks = 27